/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';
import C4DCardFooter from '../card/card-footer';
import styles from './feature-card.scss';

const { prefix, stablePrefix: c4dPrefix } = settings;

/**
 * Feature card footer.
 *
 * @element c4d-feature-card-footer
 */
@customElement(`${c4dPrefix}-feature-card-footer`)
class C4DFeatureCardFooter extends C4DCardFooter {
  updated(changedProperties) {
    super.updated(changedProperties);
    const { _linkNode: linkNode } = this;
    if (linkNode) {
      linkNode.classList.remove(`${prefix}--link-with-icon`);
    }
  }

  static styles = styles; // `styles` here is a `CSSResult` generated by custom WebPack loader
}

/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DFeatureCardFooter;
